// src/redux-saga/reducers/knowledgeBaseReducer.js

import {
  FETCH_KB_REQUEST,
  FETCH_KB_SUCCESS,
  FETCH_KB_FAILURE,
  CREATE_KB_REQUEST,
  CREATE_KB_SUCCESS,
  CREATE_KB_FAILURE,
  DELETE_KB_REQUEST,
  DELETE_KB_SUCCESS,
  DELETE_KB_FAILURE,
  UPDATE_KB_REQUEST,
  UPDATE_KB_SUCCESS,
  UPDATE_KB_FAILURE,
  FETCH_KB_FILES_REQUEST,
  FETCH_KB_FILES_SUCCESS,
  FETCH_KB_FILES_FAILURE,
  FETCH_KB_FILE_CONTENT_REQUEST,
  FETCH_KB_FILE_CONTENT_SUCCESS,
  FETCH_KB_FILE_CONTENT_FAILURE,
  UPLOAD_FILES_REQUEST,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAILURE,
  DELETE_KB_FILE_REQUEST,
  DELETE_KB_FILE_SUCCESS,
  DELETE_KB_FILE_FAILURE,
  FETCH_KB_SITES_REQUEST,
  FETCH_KB_SITES_SUCCESS,
  FETCH_KB_SITES_FAILURE,
  FETCH_SITE_CONTENT_REQUEST,
  FETCH_SITE_CONTENT_SUCCESS,
  FETCH_SITE_CONTENT_FAILURE,
  ADD_KB_SITE_REQUEST,
  ADD_KB_SITE_SUCCESS,
  ADD_KB_SITE_FAILURE,
  DELETE_KB_SITE_REQUEST,
  DELETE_KB_SITE_SUCCESS,
  DELETE_KB_SITE_FAILURE,
  CLEAR_FILE_CONTENT,
  DOWNLOAD_FILE_REQUEST,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
} from '../actions/knowledgeBaseActions';

const initialState = {
  data: [],
  files: {}, // Object mapping kbId to arrays of files
  sites: {}, // Object mapping kbId to arrays of sites
  fileContent: null,
  siteContent: null,
  fileDownload: null,
  loading: false,
  error: null,
};

const knowledgeBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Generic loading state
    case FETCH_KB_REQUEST:
    case CREATE_KB_REQUEST:
    case DELETE_KB_REQUEST:
    case UPDATE_KB_REQUEST:
    case FETCH_KB_FILES_REQUEST:
    case FETCH_KB_FILE_CONTENT_REQUEST:
    case UPLOAD_FILES_REQUEST:
    case DELETE_KB_FILE_REQUEST:
    case FETCH_KB_SITES_REQUEST:
    case FETCH_SITE_CONTENT_REQUEST:
    case ADD_KB_SITE_REQUEST:
    case DELETE_KB_SITE_REQUEST:
      return { ...state, loading: true, error: null };

    // Knowledge Base success handlers
    case FETCH_KB_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case CREATE_KB_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload],
      };

    case DELETE_KB_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((kb) => kb.id !== action.payload),
      };

    case UPDATE_KB_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((kb) =>
          kb.id === action.payload.id ? { ...kb, ...action.payload } : kb
        ),
      };

    // File-related success handlers
    case FETCH_KB_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: {
          ...state.files,
          [action.payload.kbId]: action.payload.files,
        },
      };

    case FETCH_KB_FILE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        fileContent: action.payload,
      };

    case UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: {
          ...state.files,
          [action.payload.kbId]: [
            ...(state.files[action.payload.kbId] || []),
            ...action.payload.files,
          ],
        },
      };

    case DELETE_KB_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        files: {
          ...state.files,
          [action.payload.kbId]: state.files[action.payload.kbId].filter(
            (file) => file.id !== action.payload.fileId
          ),
        },
      };

      case DOWNLOAD_FILE_REQUEST:
      return { ...state, loading: true, error: null };

    case DOWNLOAD_FILE_SUCCESS:
      return { ...state, loading: false, fileDownload: action.payload };

    case DOWNLOAD_FILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Site-related success handlers
    case FETCH_KB_SITES_SUCCESS:
      return {
        ...state,
        loading: false,
        sites: {
          ...state.sites,
          [action.payload.kbId]: action.payload.sites,
        },
      };

    case FETCH_SITE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        siteContent: action.payload,
      };

    case ADD_KB_SITE_SUCCESS:
      return {
        ...state,
        loading: false,
        sites: {
          ...state.sites,
          [action.payload.kbId]: [
            ...(state.sites[action.payload.kbId] || []),
            action.payload.site,
          ],
        },
      };

    case DELETE_KB_SITE_SUCCESS:
      return {
        ...state,
        loading: false,
        sites: {
          ...state.sites,
          [action.payload.kbId]: state.sites[action.payload.kbId].filter(
            (site) => site.id !== action.payload.siteId
          ),
        },
      };

    // Clear file content
    case CLEAR_FILE_CONTENT:
      return {
        ...state,
        fileContent: null,
      };

    // Failure handlers
    case FETCH_KB_FAILURE:
    case CREATE_KB_FAILURE:
    case DELETE_KB_FAILURE:
    case UPDATE_KB_FAILURE:
    case FETCH_KB_FILES_FAILURE:
    case FETCH_KB_FILE_CONTENT_FAILURE:
    case UPLOAD_FILES_FAILURE:
    case DELETE_KB_FILE_FAILURE:
    case FETCH_KB_SITES_FAILURE:
    case FETCH_SITE_CONTENT_FAILURE:
    case ADD_KB_SITE_FAILURE:
    case DELETE_KB_SITE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default knowledgeBaseReducer;
